import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PessoaTipoBadgeFisicaComponent } from './fisica';
import { PessoaTipoBadgeJuridicaComponent } from './juridica';
import { PessoaTipoBadgeCentralComprasComponent } from './central-compras';
import { PessoaTipoBadgeComponent } from './pessoa-tipo-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PessoaTipoBadgeFisicaComponent,
        PessoaTipoBadgeJuridicaComponent,
        PessoaTipoBadgeCentralComprasComponent,
        PessoaTipoBadgeComponent
    ],
    exports: [
        PessoaTipoBadgeComponent
    ]
})
export class PessoaTipoBadgeModule { }
